/* eslint-disable react/jsx-curly-brace-presence */
import React, { memo, useEffect, useState } from 'react';

import Link from 'next/link';
import { useSelector } from 'react-redux';

import { IState } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';

import NewsLetter from './NewsLetter';
import * as S from './styles';

interface IFooterProps {
  initialPages?: boolean;
  children?: React.ReactNode;
}

const Footer: React.FC<IFooterProps> = ({ initialPages }) => {
  const { redesSociais } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  const [haveSocialMedias, setHaveSocialMedias] = useState(false);

  useEffect(() => {
    if (redesSociais) {
      const haveSM = Object.values(redesSociais).some(
        item => item !== null && item !== '',
      );

      setHaveSocialMedias(haveSM);
    }
  }, [redesSociais]);

  return (
    <S.Container className="footer">
      {!initialPages && (
        <>
          <NewsLetter />

          <div className="footer-background-body">
            <div className="footer-body">
              <div className="footer-body-info space">
                <div className="footer-body-group">
                  <div>
                    <h4 className="footer-title">Sobre a Ultrafarma</h4>

                    <ul>
                      {/* <li>
                        <Link href="/pagina/premiacoes" passHref>
                          <a className="link">
                            Premiações
                          </a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/trabalhe-conosco" passHref>
                          <a className="link">
                            Trabalhe Conosco
                          </a>
                        </Link>
                      </li> */}

                      <li>
                        <Link href="/pagina/nossa-historia" passHref>
                          <a className="link">Nossa história</a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/pagina/nossa-loja" passHref>
                          <a className="link">Nossa Loja</a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/pagina/imprensa" passHref>
                          <a className="link">Imprensa</a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/pagina/responsabilidade-social" passHref>
                          <a className="link">Responsabilidade Social</a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/pagina/nossos-parceiros" passHref>
                          <a className="link">Nossos Parceiros</a>
                        </Link>
                      </li>

                      <li>
                        <Link href="/pagina/codigo-de-etica" passHref>
                          <a className="link">Conduta e Ética</a>
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="footer-title">Atendimento</h4>

                    <ul>
                      <li>
                        <a
                          href="https://atendimento.ultrafarma.com.br/hc/pt-br"
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Atendimento ao Cliente (SAC)
                        </a>
                      </li>

                      <li>
                        <Link href="/central-do-cliente/pedidos" passHref>
                          <a className="link">Acompanhe seu Pedido</a>
                        </Link>
                      </li>

                      <li>
                        <a
                          href="https://atendimento.ultrafarma.com.br/hc/pt-br"
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          FAQ - Perguntas frequentes
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="footer-title">Segurança e Privacidade</h4>

                    <ul>
                      <li>
                        <Link href="/pagina/politica-de-privacidade" passHref>
                          <a className="link">Política de Privacidade</a>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* <div>
                  <h4 className="footer-title">Selos e Certificados</h4>

                  <ul className="footer-body-group-selos">
                    <li>
                      <a href="https://www.premioibest.com/" target="_blank">
                        <img
                          src="/images/selos/selo-ibest.svg"
                          alt="Selo IBest"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.siteblindado.com/consumidor/selo-blindado/?language1=pt&hostname=www.ultrafarma.com.br"
                        target="_blank"
                      >
                        <img
                          src="/images/selos/selo-site-blindado.svg"
                          alt="Site Blindado"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://premio.reclameaqui.com.br/resultado"
                        target="_blank"
                      >
                        <img
                          src="/images/selos/selo-reclame-aqui-premio.svg"
                          alt="Prêmio Reclame Aqui 2020"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.ssllabs.com/ssltest/analyze.html?d=ultrafarma.com.br"
                        target="_blank"
                      >
                        <img
                          id="selo-encryptssl"
                          src="/images/selos/selo-site-protegido.svg"
                          alt="Certificado SSL"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.ebit.com.br/ultrafarma/selo"
                        target="_blank"
                      >
                        <img
                          src="/images/selos/selo-ebit.svg"
                          alt="NPS Awards"
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://transparencyreport.google.com/safe-browsing/search?url=ultrafarma.com.br"
                        target="_blank"
                      >
                        <img
                          src="/images/selos/selo-google-safe-browsing.svg"
                          alt="Google Safe Browsing"
                        />
                      </a>
                    </li>

                    <li>
                      <a href="" target="_blank">
                        <img
                          src="/images/selos/selo-nps-awards.svg"
                          alt="NPS Awards"
                        />
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>

              <div className="footer-body-info column">
                <div>
                  {haveSocialMedias && (
                    <div className="footer-body-social-media">
                      <h4 className="footer-title">Redes Sociais</h4>

                      <ul>
                        {redesSociais?.instagram && (
                          <li>
                            <a href={redesSociais.instagram} target="_blank">
                              <img
                                src="/images/icons/instagram.svg"
                                alt="Instagram"
                                className="icon instagram-icon"
                              />
                            </a>
                          </li>
                        )}

                        {redesSociais?.facebook && (
                          <li>
                            <a href={redesSociais.facebook} target="_blank">
                              <img
                                src="/images/icons/facebook.svg"
                                alt="Facebook"
                                className="icon facebook-icon"
                              />
                            </a>
                          </li>
                        )}

                        {redesSociais?.twitter && (
                          <li>
                            <a href={redesSociais.twitter} target="_blank">
                              <img
                                src="/images/icons/twitter.svg"
                                alt="Twitter"
                                className="icon twitter-icon"
                              />
                            </a>
                          </li>
                        )}

                        {redesSociais?.linkedin && (
                          <li>
                            <a href={redesSociais.linkedin} target="_blank">
                              <img
                                src="/images/icons/linkedin.svg"
                                alt="Linkedin"
                                className="icon linkedin-icon"
                              />
                            </a>
                          </li>
                        )}

                        {redesSociais?.youtube && (
                          <li>
                            <a href={redesSociais.youtube} target="_blank">
                              <img
                                src="/images/icons/youtube.svg"
                                alt="Youtube"
                                className="icon youtube-icon"
                              />
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  )}

                  <div className="footer-body-payment-methods">
                    <h4 className="footer-title">Formas de Pagamento</h4>

                    <ul>
                      <li>
                        <img
                          src="/images/selos/pagamento-boleto-white.svg"
                          alt="Pagamento no boleto"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-pix-white.svg"
                          alt="Pagamento no pix"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-mastercard.svg"
                          alt="Pagamento no cartão Mastercard"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-visa.svg"
                          alt="Pagamento no cartão Visa"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-american-express.svg"
                          alt="Pagamento no cartão American Express"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-elo-white.svg"
                          alt="Pagamento no cartão Elo"
                        />
                      </li>

                      <li>
                        <img
                          src="/images/selos/pagamento-jcb.svg"
                          alt="Pagamento no cartão JCB"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="footer-background-about">
        <div className="footer-about">
          <span>
            Ultrafarma Saúde EIRELI - CNPJ: 02.543.945/0006-90 Endereço: Av.
            Jabaquara, 1535 - Mirandópolis - SP. Horário de Funcionamento
            Segunda a Sábado das 07h00 ás 22h00. Site - 24 horas por dia, todos
            os dias da semana. As informações contidas neste site como promoções
            e ofertas, não devem ser usadas para automedicação e não substituem,
            em hipótese alguma, a medicação prescrita pelo profissional da área
            médica. Somente o médico está em condições de diagnosticar qualquer
            problema de saúde e prescrever o tratamento adequado. Qualquer
            dúvida sobre prescrição médica e produtos divulgados em nosso site,
            entre em contato através do atendimento por e-mail ou chat online.
            Se preferir, você poderá se dirigir a uma de nossas lojas, pois
            contamos com um profissional da área para maiores esclarecimentos.
            <br />
            As fotos contidas em nosso site são meramente ilustrativas. Os
            preços e as promoções, são válidos apenas para compras via Internet.
            Preços e disponibilidade sujeitos a alterações no decorrer do dia **
            As parcelas mínimas nos cartões que aceitam parcelamento são de R$
            20,00.
            <br />
            Copyright © 2014 - 2025 - Ultrafarma Saúde EIRELI. Todos os direitos
            reservados.
          </span>
        </div>
      </div>
    </S.Container>
  );
};

export default memo(Footer);
